var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.73834,
    y: 5.33008,
    width: 1.76702,
    height: 5.30105,
    rx: 0.883508,
    fill: "#64748B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.08783,
    y: 6.65527,
    width: 1.76702,
    height: 2.65052,
    rx: 0.883508,
    fill: "#64748B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.38892,
    y: 3.56445,
    width: 1.76702,
    height: 8.83508,
    rx: 0.883508,
    fill: "#64748B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03955,
    y: 5.33008,
    width: 1.76702,
    height: 5.30105,
    rx: 0.883508,
    fill: "#64748B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.69,
    y: 6.65527,
    width: 1.76702,
    height: 2.65052,
    rx: 0.883508,
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWave);
export default __webpack_public_path__ + "static/media/audio_wave.a6540cefd52b6542eb1c49eb8ecf268c.svg";
export { ForwardRef as ReactComponent };